import { NotificationStrategy, NotificationWorkflowContext } from '../types';

export async function onReject(
  strategy: NotificationStrategy,
  context: NotificationWorkflowContext,
) {
  return strategy.reject(context);
}
